import { Typography } from "@mui/material";
import type { MsalAuthenticationResult } from "@azure/msal-react";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import { globalStyles } from "../styles/useStyles";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

interface ErrorCardProps {
  headerText: string;
  errorMessages: string[];
}

export const ErrorCard = (props: ErrorCardProps): JSX.Element | null => {
  const { headerText, errorMessages } = props;

  const errorContent = errorMessages.map((msg, idx) => {
    return (
      <li key={idx}>
        <Typography component="div" variant="subtitle1">
          {msg}
        </Typography>
      </li>
    );
  });

  return (
    <Box
      sx={globalStyles.errorBox}
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Container maxWidth="sm">
        <Card
          sx={globalStyles.errorCard}
          elevation={6}
        >
          <Box pt={3}>
            <Typography
              component="div"
              variant="h5"
              sx={{ textAlign: "center" }}
            >
              {headerText}
            </Typography>
            {errorContent.length > 0 && (
              <Box p={2}>
                <ul>{errorContent}</ul>
              </Box>
            )}
          </Box>
        </Card>
      </Container>
    </Box>
  );
};

export const ErrorComponent = (
  props: MsalAuthenticationResult
): JSX.Element | null => {
  const { error } = props;
  const { t } = useTranslation();
  if (!error) {
    return null;
  }

  const error_array = error.errorMessage
    .split(".")
    .map((m) => m.trim())
    .filter((m) => m.length > 0);

  return (
    <ErrorCard
      headerText={t("There was an error logging you in")}
      errorMessages={error_array}
    />
  );
};

interface CustomErrorComponentProps {
  error?: string | null;
}

export const CustomErrorComponent = (
  props: CustomErrorComponentProps
): JSX.Element | null => {
  const { error } = props;
  const { t } = useTranslation();
  if (!error) {
    return null;
  }

  return (
    <ErrorCard
      headerText={t("You cannot view this page")}
      errorMessages={[error]}
    />
  );
};
